export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/no-cars-match.492c5a7e.svg","height":192,"width":343,"blurWidth":0,"blurHeight":0};